import { render, staticRenderFns } from "./BlockWebsite.vue?vue&type=template&id=05dd133d"
import script from "./BlockWebsite.vue?vue&type=script&lang=js"
export * from "./BlockWebsite.vue?vue&type=script&lang=js"
import style0 from "./BlockWebsite.vue?vue&type=style&index=0&id=05dd133d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports